import axios from "axios"
import { consultarFirmaContratada, getEmpresaRepresentante } from "../../helpers/helpersRepresentante"
import { log_out } from "./login.actions"

export const LINK_PDF = 'LINK_PDF'
export const DATA_FILTRADA = 'DATA_FILTRADA'
export const ARR = 'ARR'
export const PHOTO_LINK = 'PHOTO_LINK'


export const GET_EMPRESAS = 'GET_EMPRESAS'
export const SET_EMPRESA = 'SET_EMPRESA'
export const SET_FIRMA_CONTRATADA = 'SET_FIRMA_CONTRATADA'
export const SET_VIGENTES = 'SET_VIGENTES'


export const linkPDF = (link) => ({
    type:LINK_PDF,
    payload:link
})

export const setVigentes = () => ({
    type:SET_VIGENTES
})



export const photoLink = (photo) => ({
    type:PHOTO_LINK,
    payload:photo
})



export const setEmpresa = (empresa) => ({
    type:SET_EMPRESA,
    payload:empresa
})

export const getEmpresasSlice = (empresas) => ({
    type:GET_EMPRESAS,
    payload:empresas
})



export const getEmpresas = (data) => {

    return async (dispatch,getstate) => {  

       const {sid,strcon,codigo} = data
      


            try {


                const response = await axios.get(`${process.env.REACT_APP_API_URL_BACK}/api/carpeta/empresas/${sid}`,{
                    headers:{
                      'sid':sid,
                      'strcon':strcon,
                      'codigo':codigo
                   }
                   })
                
     

                // hacemos el select de las empresas -------------------------------------------------------
                let empresas = []
                 empresas = response.data.map(item => {
                    return {label: item.razsoc, value:item.empid}
                })

             
                // Verificamos las empresas con firma contratada o en prueba

                  const empresasFirmaContratada = []

                  for (const empresa of empresas) {
  
                     const [response] =  await consultarFirmaContratada(sid,empresa.value)

                     
               
                     if(response.firmadigital === 'S' || response.firmadigital === 'P' ) { empresasFirmaContratada.push(empresa) }

                  }

                //  de las empresas con firma disponible vemos de cual es representante el usuario

           

                  const empresaFirmaContratadaYRepresentante = []

                  for (const empresa of empresasFirmaContratada) {

                      
                    const [response] =  await getEmpresaRepresentante(sid,empresa.value,codigo)
               
                    if(response?.codigo === codigo.toUpperCase() ) { empresaFirmaContratadaYRepresentante.push(empresa) }
                  }


           
                if( empresaFirmaContratadaYRepresentante.length === 0 ){ 

                    alert('No eres representante de ninguna empresa')
                     localStorage.removeItem('vencimiento')

                     dispatch(log_out())
                }
                    
                // si solo es representante de 1 empresa se la seleccionamos de inmediato
                // si no le mostramos el select para que seleccione

                if(empresaFirmaContratadaYRepresentante.length === 1){

                    dispatch(setEmpresa(empresaFirmaContratadaYRepresentante[0]))
          
                }

                // si es representante de mas de 1 le damos a elegir

                empresaFirmaContratadaYRepresentante.unshift({label:'Selecciona Empresa',value:'Selecciona Empresa'})

                dispatch(getEmpresasSlice(empresaFirmaContratadaYRepresentante))

                
            } catch (error) {
                console.log(error)
           


            }



}}
